import { NgModule } from '@angular/core';
import { translationChunksConfig, translations } from "@spartacus/assets";
import { FeaturesConfig, I18nConfig, OccConfig, provideConfig, SiteContextConfig } from "@spartacus/core";
import { defaultB2bOccConfig } from "@spartacus/setup";
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from "@spartacus/storefront";
import { EffectsModule } from '@ngrx/effects';
import { environment } from 'src/environments/environment';
import { GonvarriCartEntryEffects } from 'src/app/core/effects/gonvarri-cart-entry.effect';
import {GonvarriQuoteEntryEffects} from "../../../../../src/app/core/effects/gonvarri-quote-entry.effect";
import {GonvarriAnonymousConsentsEffects} from "../../../../../src/app/core/effects/gonvarri-anonymous-consents.effect";
import {GonvarriSavedCartEffects} from "../../../../../src/app/core/effects/gonvarri-saved-cart.effect";

export const gonvarriSharedSpartacusConfigurationEffects = EffectsModule.forFeature([
  GonvarriCartEntryEffects,
  GonvarriQuoteEntryEffects,
  GonvarriAnonymousConsentsEffects,
  GonvarriSavedCartEffects
]);

@NgModule({
  declarations: [],
  imports: [
    gonvarriSharedSpartacusConfigurationEffects
  ],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    environment.b2bOccConfig,
    provideConfig(<SiteContextConfig>{
      context: {
        currency: ['EUR'],
        language: ['es'],
        baseSite: ['gonvarriBarcelona-spa'],
        urlParameters: ['baseSite', 'language', 'currency'],
      },
    }), provideConfig(<I18nConfig>{
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
        fallbackLang: 'en'
      },
    }), provideConfig(<FeaturesConfig>{
      features: {
        level: '2211.32'
      }
    }), provideConfig(defaultB2bOccConfig)]
})
export class SpartacusConfigurationModule { }
